"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ = require("../");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AssignedDriver(props) {
  return /*#__PURE__*/_react.default.createElement(_.Box, {
    style: {
      width: "100%"
    },
    br: "m",
    p: "l",
    bg: "common.white"
  }, /*#__PURE__*/_react.default.createElement(_.Stack, {
    distribution: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_.Stack, null, /*#__PURE__*/_react.default.createElement(_.Box, null, /*#__PURE__*/_react.default.createElement(_.Typography, {
    color: "text.light950",
    fs: "s"
  }, "\u0633\u0641\u06CC\u0631 \u0634\u0645\u0627"), /*#__PURE__*/_react.default.createElement(_.Typography, {
    ff: "mainBold"
  }, props.data.first_name, " ", props.data.last_name))), props.info));
}

var _default = AssignedDriver;
exports.default = _default;